import { InventoryItem } from '../../app/resources/types';
import { MS_IN_DAY } from '../../utils/time-utils';
import type { WinStreakConfig } from './types';

import { EventConditionType } from '../../app/state/events/types';

export const winStreakConfigs: WinStreakConfig[] = [
  {
    levels: 101,
    duration: MS_IN_DAY * 4,
    chests: [
      {
        level: 3,
        rewards: {
          [InventoryItem.Coin]: 50,
        },
      },
      {
        level: 8,
        rewards: {
          [InventoryItem.Coin]: 100,
          [InventoryItem.BoosterHammer]: 1,
        },
      },
      {
        level: 15,
        rewards: {
          [InventoryItem.Coin]: 200,
          [InventoryItem.BoosterHammer]: 1,
          [InventoryItem.BoosterRedraw]: 1,
        },
      },
      {
        level: 22,
        rewards: {
          [InventoryItem.Coin]: 200,
          [InventoryItem.BoosterMove]: 1,
        },
      },
      {
        level: 29,
        rewards: {
          [InventoryItem.Coin]: 200,
          [InventoryItem.BoosterRedraw]: 1,
        },
      },
      {
        level: 37,
        rewards: {
          [InventoryItem.Coin]: 300,
          [InventoryItem.BoosterHammer]: 2,
        },
      },

      {
        level: 45,
        rewards: {
          [InventoryItem.Coin]: 300,
          [InventoryItem.BoosterRedraw]: 2,
        },
      },

      {
        level: 53,
        rewards: {
          [InventoryItem.Coin]: 300,
          [InventoryItem.BoosterHammer]: 1,
          [InventoryItem.BoosterRedraw]: 1,
        },
      },
      {
        level: 62,
        rewards: {
          [InventoryItem.Coin]: 450,
          [InventoryItem.BoosterMove]: 1,
        },
      },
      {
        level: 71,
        rewards: {
          [InventoryItem.Coin]: 450,
          [InventoryItem.BoosterHammer]: 2,
          [InventoryItem.BoosterRedraw]: 2,
        },
      },
      {
        level: 80,
        rewards: {
          [InventoryItem.Coin]: 450,
          [InventoryItem.BoosterRedraw]: 2,
          [InventoryItem.BoosterMove]: 1,
        },
      },
      {
        level: 90,
        rewards: {
          [InventoryItem.Coin]: 700,
          [InventoryItem.BoosterHammer]: 3,
        },
      },
      {
        level: 100,
        rewards: {
          [InventoryItem.Coin]: 800,
          [InventoryItem.BoosterHammer]: 3,
          [InventoryItem.BoosterRedraw]: 3,
          [InventoryItem.BoosterMove]: 3,
        },
      },
    ],
    eventId: 'winStreakRegular',
    conditions: [
      { type: EventConditionType.ReachedLevel, level: 10 },
      { type: EventConditionType.WinStreakCooldown, cooldown: MS_IN_DAY * 5 },
    ],
  },
];
